// extracted by mini-css-extract-plugin
export default {"root":"avDauMTT","content":"wFcOKTv6","app":"nMx8Onpd","auth":"Zepj9B29","onboarding":"vasTfV2I","scrolled":"A3wIOVMb"};